import React, { useState ,useMemo} from 'react'
import { ConfirmDialog } from '../ConfirmDialog'
import { Autocomplete, TextField ,debounce} from '@mui/material'
import { ComponentState } from '../../../common/models/component-state.model';
import { CommonUtils } from '../../../common/services/common-utils';
import { UserService } from '../../../users/user.service';
import { UserModel } from '../../../common/models/user-account.model';
import AuthService from '../../../../services/auth.service';
import { BusyIndicator } from '../BusyIndicator';
import { MessageAlert } from '../MessageAlert';
const SwitchUser = (props:any) => {
    const userService = UserService.Instance;
    const authService = AuthService.Instance;
    
    const [userList,setUserList]= useState<UserModel[]>([])
    const [selectedUser,setSelectedUser]= useState('')
    const [state, setState] = React.useState<ComponentState>({ isLoading: false });
    function handleClose(){
      props.setIsOpenSwitchUserPopup(false)
    }
    async function handleSubmit(){
      setState({isLoading:true})
      props.setIsOpenSwitchUserPopup(false)
      const res = await authService.switchUser(selectedUser);
      window.location.reload()
      setState({isLoading:false})
    }
    const onAutoCompleteChange = (keyword: string, minRole?: number) => {
      if (!keyword) return;
      setState({ isLoading: true });
      userService.searchUsers(keyword, minRole).then(res => {
        setUserList(res);
        setState({ isLoading: false });
      }).catch((err) => {
        setState({ isLoading: true, messageAlert: CommonUtils.setErrorMessage(err) });
      });
    }
     const onAutoCompleteInputChange = useMemo(() => debounce((keyword: string, minRole?: number) => onAutoCompleteChange(keyword, minRole), 700), []);
  return (
    <div>
      <MessageAlert message={state?.messageAlert}></MessageAlert>
      <BusyIndicator loading={state?.isLoading}></BusyIndicator>
        <ConfirmDialog 
            maxWidth='lg'
            dialogTile='Switch User'
            open={true}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            isLoading={false}
            >
              <Autocomplete 
              sx={{width:500,marginTop:1}}
              options={userList?.map((userObj)=>userObj?.emailId)}
              onChange={()=>{
              }}
              onInputChange={(event,val)=>{
                onAutoCompleteInputChange(val)
                setSelectedUser(val)
              }}
              renderInput={(params) => {
              return <TextField {...params} label="search user email..." sx={{
                bgcolor: 'background.paper',
                boxShadow: 1,
                borderRadius: 2
              }} />
            }}
              />
        </ConfirmDialog>
    </div>
  )
}

export default SwitchUser